import { CountryEnum } from '@systemeio/ui'

export const europeanCountries = [
  CountryEnum.Austria,
  CountryEnum.Belgium,
  CountryEnum.Bulgaria,
  CountryEnum.Croatia,
  CountryEnum.Cyprus,
  CountryEnum.CzechRepublic,
  CountryEnum.Denmark,
  CountryEnum.Estonia,
  CountryEnum.Finland,
  CountryEnum.France,
  CountryEnum.Germany,
  CountryEnum.Greece,
  CountryEnum.Hungary,
  CountryEnum.Ireland,
  CountryEnum.Italy,
  CountryEnum.Latvia,
  CountryEnum.Lithuania,
  CountryEnum.Luxembourg,
  CountryEnum.Malta,
  CountryEnum.Netherlands,
  CountryEnum.Poland,
  CountryEnum.Portugal,
  CountryEnum.Romania,
  CountryEnum.Slovakia,
  CountryEnum.Slovenia,
  CountryEnum.Spain,
  CountryEnum.Sweden,
]
